<template>
  <div class="invoiceItemListDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-field
        v-model="form.ItemName"
        :label="$t.invoiceItemList.itemName"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.ItemNameEn"
        :label="$t.invoiceItemList.itemNameEn"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "invoiceItemListDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      itemId: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { ItemId, IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      if (ItemId) {
        this.itemId = ItemId;
        this.getInvoiceItemDetail();
      }
    } else {
      this.form = {
        ItemName: "",
        ItemNameEn: "",
      };
    }
  },
  methods: {
    getInvoiceItemDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          ItemId: this.itemId,
        };
        this.$api.financialManagement
          .getInvoiceItemDetail(param)
          .then((res) => {
            this.form = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.isEdit) {
        param.ItemId = this.itemId;
        request = this.$api.financialManagement.editInvoiceItem(param);
      } else {
        request = this.$api.financialManagement.addInvoiceItem(param);
      }
      request
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.operateSuccess,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.invoiceItemListDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
